import Vue__default from "vue";
import { default as default2 } from "vue";
function set(target, key, val) {
  return Vue__default.set(target, key, val);
}
function del(target, key) {
  return Vue__default.delete(target, key);
}
export {
  default2 as default,
  del,
  set
};
